import Layout from '../layout/index.vue'

export default [{
        path: '/control',
        name: 'control',
        component: Layout,
        redirect: 'control/form/index',
        children: [{
            path: 'form/index',
            component: () => import('../views/control/form/index.vue')
        },{
            path: 'form/info',
            component: () => import('../views/control/form/info.vue')
        },
		{
		    path: 'excelList',
		    component: () => import('../views/control/excelList.vue')
		},
		{
		    path: 'production',
		    component: () => import('../views/control/production.vue')
		},
		{
		    path: 'report',
		    component: () => import('../views/control/report.vue')
		},
		]
    },

];